/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'rarely' }, { id: 'yearly' }, { id: 'fewYear' }, { id: 'constantly' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-change-frequency"
      progress={64}
      field="hairstyleWomenChangeFrequency"
      setter="setHairstyleWomenChangeFrequency"
      ns="hairstyleWomenChangeFrequency"
      options={OPTIONS}
    />
  );
}

export default Page;
